import React from 'react';
import { useIntl } from 'react-intl';
import { MdClose } from 'react-icons/md';
import AttachmentTile from './AttachmentTile';
import { useAttachmentPreview } from './useAttachmentPreview';
import type { PreviewableAttachment } from './types';
import { TrayList, TileWrapper, RemoveButton } from './AttachmentTray.styled';

export interface AttachmentTrayProps {
  items: PreviewableAttachment[];
  /** Supplied by the composer to make chips removable before sending. */
  onRemove?: (index: number) => void;
  align?: 'start' | 'end';
}

const AttachmentTray: React.FC<AttachmentTrayProps> = ({ items, onRemove, align = 'start' }) => {
  const intl = useIntl();
  const { activate, overlay } = useAttachmentPreview(items);

  if (items.length === 0) return null;

  return (
    <>
      <TrayList $align={align} data-testid="attachment-tray">
        {items.map((item, index) => (
          <TileWrapper key={item.key}>
            <AttachmentTile item={item} onActivate={activate(item)} />
            {onRemove && (
              <RemoveButton
                type="button"
                data-remove
                onClick={() => onRemove(index)}
                aria-label={intl.formatMessage(
                  { id: 'attachments.remove', defaultMessage: 'Remove {name}' },
                  { name: item.filename },
                )}
              >
                <MdClose />
              </RemoveButton>
            )}
          </TileWrapper>
        ))}
      </TrayList>
      {overlay}
    </>
  );
};

export default AttachmentTray;
